// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Burkina Faso */
const BF = /^(?:(?:0[1-7]|4[4-6]|5[0-8]|[67]\d)\d{6})$/;

export default BF;
